<template>
    <div class="level">
        <div class="level-left">
            <div class="header">
                <h1 :class="['title', 'is-'+size]" v-if="title">{{ title }}</h1>
                <slot name="left"></slot>
            </div>
        </div>
        <div class="level-right">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        size: {
            type: String,
            default: '4'
        },
    }
}
</script>
